import Vue from 'vue'
import api from '@/utils/api'

export async function downloadFile (apiName, params, fileName) {
  let res = await api[apiName](params)
  try {
    const text = await res.text()
    const json = JSON.parse(text)
    console.log(json, '下载报错提示');
    if(json && json.code !== '00000') {
      return Vue.prototype.$message.error(json.msg)
    }
  } catch {
    const url = window.URL.createObjectURL(
      new Blob([res], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
      })
    )
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    const excelName = fileName
    link.setAttribute('download', excelName)
    document.body.appendChild(link)
    link.click()
    link.remove()
    Vue.prototype.$message.success('下载成功！')
  }
}
